<template>
  <v-dialog
    v-model="localOpen"
    eagle
    persistent
    :width="fullscreen ? '' : modalWidth"
    :height="fullscreen ? '' : modalHeight"
    :fullscreen="fullscreen"
  >
    <v-card
      v-if="localOpen"
      data-test="base-modal"
    >
      <v-card-title v-if="!!title">
        <v-row no-gutters>
          <v-col>
            <v-row no-gutters>
              <v-col data-test="titulo-modal">
                <h1 class="titulo-modal word-break-modal">{{ title }}</h1>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <v-divider />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text
        :style="heightStyle"
        class="py-4"
      >
        <v-row no-gutters>
          <v-col>
            <slot></slot>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions
        class="pa-0 ma-0"
        v-if="!hideActionBar"
      >
        <v-col class="text-right">
          <v-btn
            v-if="!hidePrimaryButton"
            text
            class="btn-primary mr-2"
            data-test="btn-primary-modal"
            :loading="primaryButtonLoading"
            @click="primaryButtonAction"
          >
            {{ primaryButtonText }}
          </v-btn>
          <v-btn
            v-if="!hideSecondaryButton"
            text
            class="btn-tertiary"
            data-test="btn-secondary-modal"
            @click="secondaryButtonAction"
          >
            {{ secondaryButtonText }}
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseModal',

  inject: ['appData'],

  model: {
    prop: 'open',
    event: 'onChange'
  },

  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: '' },
    primaryButtonAction: { type: Function, default: () => {} },
    secondaryButtonAction: { type: Function, default: () => {} },
    primaryButtonText: { type: String, default: 'Salvar' },
    secondaryButtonText: { type: String, default: 'Cancelar' },
    hidePrimaryButton: { type: Boolean, default: false },
    hideSecondaryButton: { type: Boolean, default: false },
    hideActionBar: { type: Boolean, default: false },
    primaryButtonLoading: { type: Boolean, default: false },
    modalWidth: { type: String, default: '80dvw' },
    modalHeight: { type: String, default: '80dvh' },
    maxHeightBody: { type: String, default: '70dvh' },
    fullscreen: { type: Boolean, default: false }
  },

  computed: {
    localOpen: {
      get() {
        return this.open;
      },
      set(valor) {
        this.$emit('onChange', valor);
      }
    },

    heightStyle() {
      const titleLimit = 30;
      const defaultHeight = '120px';
      const heightToDisconsider = '150px';

      let height = defaultHeight;

      if (this.appData.isMobile)
        height = this.title?.length > titleLimit ? heightToDisconsider : defaultHeight;

      return {
        height: this.fullscreen ? `calc(100dvh - ${height})` : this.maxHeightBody,
        overflow: 'auto'
      };
    }
  },

  watch: {
    open(open) {
      this.handleScrollMainPage(open);
    }
  },

  methods: {
    handleScrollMainPage(apply) {
      const style = apply ? 'hidden' : '';

      document.documentElement.style.overflow = style;
      document.body.style.overflow = style;
    }
  }
};
</script>

<style scoped>
.word-break-modal {
  word-break: keep-all;
  overflow-wrap: break-word;
  hyphens: none;
}
</style>
